import ButtonCustom from 'components/_parts/atoms/button';
import Label from 'components/_parts/atoms/label';
import { Hooks } from 'providers';
import queryString from 'query-string';
import { useContext, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import InfoPng from 'assets/img/infoPopUp.png';
import { useDeleteCompLibrary } from 'components/company/api/useCompetencyAndSkillGroup';
import { inquiryProps } from 'components/types/company';

function ModalInquiry({ competencyId, datas }: inquiryProps) {
  const { t } = useTranslation();
  const { showInquiryComp, setShowInquiryComp } = useContext(Hooks);
  const { inquiry } = useSelector((state) => ({
    inquiry: state?.company?.competency_inquiry,
  }));

  const { mutate: deleteCompLibrary } = useDeleteCompLibrary();

  const clickOut = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (clickOut.current && !clickOut?.current?.contains(e.target)) {
        setShowInquiryComp(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [clickOut]);

  return (
    <div
      ref={clickOut}
      className={`custom_option_search custom_option_search-inquiry ${showInquiryComp ? 'show' : ''}`}
      style={{
        width: '36%',
        top: '40%',
        left: '50%',
        boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.3)',
        maxHeight: 'none',
        borderRadius: '20px',
        lineHeight: '1.5',
        padding: '30px',
        fontFamily: 'poppins',
      }}
    >
      <div className="w-100 mb-4" style={{ textAlign: 'center' }}>
        <img src={InfoPng} alt="infoIcon.png" style={{ height: '80px' }} />
      </div>
      <Label className="mb-3" style={{ fontSize: '12px' }}>
        The competency to be deleted is currently being used in the job description:
      </Label>
      <div style={{
        display: 'grid', gridTemplateColumns: 'auto auto', paddingLeft: '16px', fontSize: '10px', columnGap: '20px', maxHeight: '250px', overflow: 'auto',
      }}
      >
        { inquiry?.length > 0
          ? inquiry?.map((item) => (
            <div key={item.job_level_id} className="mb-1 itemInquiry">
              {item.organization_name}
            </div>
          ))
          : (
            <div className="mb-1 itemInquiry">
              Not used in any job description
            </div>
          )}
      </div>

      <Label className="mb-1 mt-3" typeLabel="label_option">
        Are you sure delete this data ?
      </Label>
      <div
        className="w-100 mt-3 d-flex justify-content-center align-items-center"
        style={{ gap: '20px' }}
      >
        <ButtonCustom
          style={{ width: '70px', height: '35px' }}
          func={() => {
            const deletePayload = {
              competency_id: competencyId,
              datas,
            };
            deleteCompLibrary(deletePayload);

            setShowInquiryComp(false);
          }}
        >
          Yes
        </ButtonCustom>
        <ButtonCustom
          style={{
            width: '70px', height: '35px', backgroundColor: '#fff', color: '#3D5AFE', border: '1px solid #3D5AFE',
          }}
          func={() => setShowInquiryComp(false)}
        >
          No
        </ButtonCustom>
      </div>
    </div>
  );
}

export default ModalInquiry;
